export default __webpack_public_path__ + "images/pictograms/print-demand.svg?1f4fd4eb2d54d3569e39cef1a04aafdc339462345ce358ea62a5d74c63255330";